import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { CrBreadcrumb } from "../components/CrBreadcrumb";
import { CrExplainer } from "../components/CrExplainer";
import { CronTool } from "../components/CronTool";

export function CronExplainerPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <CrBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.cr_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.cr_intro()}
          </p>
        </header>

        <CronTool />

        <CrExplainer
          howTo={m.cr_howto()}
          faqs={[
            { q: m.cr_faq1_q(), a: m.cr_faq1_a() },
            { q: m.cr_faq2_q(), a: m.cr_faq2_a() },
            { q: m.cr_faq3_q(), a: m.cr_faq3_a() },
            { q: m.cr_faq4_q(), a: m.cr_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
